module.exports = __webpack_public_path__ + "static/media/presentation_1.d3a5c74a.svg";